import React, { Component } from 'react';
import ResumenCreacion from './ResumenCreacion';
import CardForm from '../../../../Utils/Cards/CardForm';
import { PrintContainer, actions as printActions } from 'Utils/Print';
import './ResumenCreacionClass.css';

export default class ResumenCreacionClass extends Component {
    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    /**
     * Función para redirigir a la vista anterior.
     * @returns {void}
     */
    regresar = () => {
        this.props.history.goBack();
    }

    /**
     * Función que serviría para imprimir el resumen de creación de recepciones.
     * @param {*} event - Evento de impresión.
     * @returns {void}
     */
    imprimir = (event) => {
        this.setState({
        }, () => printActions.print('recepciones-contenedores'));
    }

    render() {
        const { viaje_id } = this.props.match.params;

        return (
            <div className="mb-4 col-12">
                <CardForm
                    icon="recepciones_activo"
                    titulo="RECEPCIÓN"
                    subtitulo="Nuevo"
                    col="12">
                    <ResumenCreacion viaje_id={viaje_id} regresar={this.regresar} imprimir={this.imprimir} />
                </CardForm>
            </div>
        )
    }
}
